export default function getMatrixWidth(matrix) {
    if (!matrix) {
        return 0;
    }

    return matrix.reduce((width, row) => Math.max(width, row.length), 0);
}
